import { RoleType } from 'api/types/entity';
import { GridFields } from 'components';
import { useIsFormEditable } from 'hooks';
import { useTranslation } from 'libs/i18n';

import { Field, useFormContext } from '../../forms/adminForm';

export const AdminFormContent = () => {
  const { t } = useTranslation();

  // remove super-admin role
  const roles = Object.values(RoleType).filter(
    (v) => v !== RoleType.Superadmin && v !== RoleType.Admin
  );

  const { initialValues, readOnly } = useFormContext();

  const isSuperadmin = initialValues?.role.value === RoleType.Superadmin;

  const editable = useIsFormEditable();

  return (
    <GridFields>
      <Field.Text
        fullWidth
        readOnly
        disabled={editable}
        label={t('admin.fields.email.label')}
        name="email"
        placeholder={t('admin.fields.email.placeholder')}
      />
      <Field.Text
        fullWidth
        label={t('admin.fields.position.label')}
        name="position"
        placeholder={t('admin.fields.position.placeholder')}
      />
      <Field.Autocomplete
        hideClearIcon
        showRequiredMark
        label={t('admin.fields.role.label')}
        name="role"
        optionLabelKey="label"
        options={roles.map((v) => ({
          label: t(`admin.adminRoles.${v}`),
          value: v,
        }))}
        optionValueKey="value"
        placeholder={t('admin.fields.role.placeholder')}
        readOnly={isSuperadmin || readOnly}
        variant="select"
      />

      <Field.Text
        fullWidth
        showRequiredMark
        label={t('admin.fields.lastName.label')}
        name="lastName"
        placeholder={t('admin.fields.lastName.placeholder')}
      />
      <Field.Text
        fullWidth
        showRequiredMark
        label={t('admin.fields.firstName.label')}
        name="firstName"
        placeholder={t('admin.fields.firstName.placeholder')}
      />
      <Field.Text
        fullWidth
        label={t('admin.fields.middleName.label')}
        name="middleName"
        placeholder={t('admin.fields.middleName.placeholder')}
      />
    </GridFields>
  );
};
